import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MyService } from '../../shared/api/my.service';
import { KaisatsuResponseError } from '../../shared/api/response.error';
import { User } from '../../shared/api/types';
import { GlobalMessageService } from '../../shared/global-message.service';
import { kaisatsuHandleError } from '../../shared/kaisatsu-error-handler';
import { SchoolService } from '../../shared/api/school.service';
import { NgIf } from '@angular/common';
import { HeaderComponent } from '../../shared/header/header.component';
import { SpenHeading, SpenButton } from '@classi/spen';
import { GlobalMessageComponent } from '../../shared/global-message/global-message.component';
import { UsernameSettingFormComponent } from './username-setting-form/username-setting-form.component';
import { PasswordNotesComponent } from '../../shared/password-notes/password-notes.component';
import { PasswordSettingFormComponent } from './password-setting-form/password-setting-form.component';
import { FooterComponent } from '../../shared/footer/footer.component';

@Component({
  selector: 'app-login-setting',
  templateUrl: './login-setting.component.html',
  styleUrls: ['./login-setting.component.scss'],
  imports: [
    NgIf,
    HeaderComponent,
    SpenHeading,
    GlobalMessageComponent,
    SpenButton,
    RouterLink,
    UsernameSettingFormComponent,
    PasswordNotesComponent,
    PasswordSettingFormComponent,
    FooterComponent,
  ],
})
export class LoginSettingComponent implements OnInit, OnDestroy {
  user: User | null = null;
  emailSettable = false;
  iframe = false;
  constructor(
    private readonly myService: MyService,
    private readonly schoolService: SchoolService,
    private readonly globalMessageService: GlobalMessageService,
    private readonly route: ActivatedRoute,
    private readonly titleService: Title
  ) {}

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle(this.route.snapshot.data.title);
    this.iframe = this.route.snapshot.queryParamMap.get('iframe') === 'true';

    try {
      this.user = await this.myService.getStatuses();
      const passwordResetByEmail = (await this.schoolService.getLoginOptions())
        .password_reset_by_email;
      // 保護者またはメールアドレス登録が許可されている場合はメールアドレスの登録・変更を許可する
      if (
        this.user.account_type === 'parent' ||
        passwordResetByEmail[this.user.account_type]
      ) {
        this.emailSettable = true;
      }
    } catch (e: KaisatsuResponseError | unknown) {
      if (e instanceof KaisatsuResponseError) {
        // グローバルに表示するエラーメッセージをここで保存
        this.globalMessageService.setErrorMessage(e.messages);
      } else {
        kaisatsuHandleError(e, this.globalMessageService);
      }
    }
  }
  ngOnDestroy(): void {
    this.globalMessageService.delete();
  }
}
